import React from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/tmc/Layout";
import { SECTIONS } from "@/pages/Terms";
import { ShieldAlert, ArrowLeft } from "lucide-react";

export default function TermsView() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-background terminal-bg py-10 px-4 sm:px-8">
      <div className="w-full max-w-3xl mx-auto fade-up" data-testid="terms-view-page">
        <button onClick={() => nav(-1)} data-testid="terms-view-back" className="text-sm text-muted-foreground hover:text-white flex items-center gap-1 mb-5">
          <ArrowLeft className="w-4 h-4" /> Powrót
        </button>
        <div className="flex items-center justify-center mb-6"><Logo size={44} /></div>
        <div className="tmc-card overflow-hidden">
          <div className="bg-primary/10 border-b border-primary/30 px-6 py-5 flex items-start gap-3">
            <ShieldAlert className="w-6 h-6 text-primary shrink-0 mt-0.5" />
            <div>
              <h1 className="font-head text-lg sm:text-xl font-bold text-white">Regulamin i Oświadczenie o Ryzyku</h1>
              <p className="text-sm text-muted-foreground mt-1">The Money Club Bot · zawsze dostępny dla użytkowników.</p>
            </div>
          </div>
          <div className="px-6 py-5 space-y-4 text-sm">
            {SECTIONS.map(([title, body]) => (
              <div key={title}>
                <h3 className={`font-head font-semibold mb-1 ${title.includes("BRAKU ZWROT") ? "text-primary" : "text-white"}`}>{title}</h3>
                <p className="text-muted-foreground leading-relaxed">{body}</p>
              </div>
            ))}
            <p className="text-[11px] text-muted-foreground/70 font-mono pt-2 border-t border-border">Wersja regulaminu 1.0</p>
          </div>
        </div>
        <p className="text-center text-[11px] text-muted-foreground mt-6 font-mono">Handel niesie wysokie ryzyko straty kapitału.</p>
      </div>
    </div>
  );
}
